module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/correction/asset/close.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/correction/asset/close.png
// module id = 1059
// module chunks = 418